import { GeogroupService, Partner } from '@geovelo-frontends/commons';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from './query-keys';

function useUpdateGeogroupMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      partner,
      ...params
    }: { id: number; partner?: Partner } & Parameters<typeof GeogroupService.updateGeogroup>[1]) =>
      GeogroupService.updateGeogroup(id, params, partner),
    onSuccess: (updatedGeogroup, { partner }) => {
      queryClient.setQueryData(queryKeys.partnerGeogroup.all(partner?.id), updatedGeogroup);
    },
  });
}

export default useUpdateGeogroupMutation;
